import AssistClasses from './AssistClasses.js'
import formats from '../../api/formats'
import dialogs from '../common/dialogs.js'
import forms from '../common/forms.js'
import depo from '../depo'
import profile from '../profile/index.js'

// import client from '../client'
import StepSetParameters from './StepSetParameters.js'

class DocumnentSelectType extends AssistClasses.Step {
  constructor (cxt) {
    super('Выберите пакет документов',
      (step) => step.model.deedName,
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Тип',
            hint: (model, field) => {
              return model['deedName'] || 'Введите или выберите код типа документа'
            },
            errors: (model, field) => {
              return (model['deedNumber'] !== null) && (model['deedName'] === null) && 'Неверный код типа документа' || null
            },
            name: 'deedNumber',
            events: {
              'input': (value) => {
                cxt.setDeed('deedNumber', 'deedName', value, 'BINDER:')
              }
            },
            grow: true,
            size: {sm8: true, xs6: true}
          },
          {
            fieldType: 'v-btn',
            slot: 'Выбрать',
            events: {'click': () => cxt.selectDeed('deedNumber', 'deedName', true)},
            shrink: false,
            size: {sm4: true, xs6: true}
          },
          {
            fieldType: 'v-select',
            label: 'Формат документа',
            itemValue: 'value',
            itemText: 'text',
            items: (model, field) => {
              return cxt.getDeedFormats()
            },
            name: 'deedFormat',
            shrink: false,
            size: {sm8: true, xs12: true}
          }
        ]
      },
      {
        deedNumber: null,
        deedName: null,
        deedFormat: 'docx'
      }
    )
    this.context = cxt
    this.nextEnabled = () => this.model['deedName'] !== null
    this.editable = true
  }
  next (model, cb) {
    model.setCurrentStep(1)
    delete model.currentOperation
    this.context.updateData(model)
    return model
  }
}

class ChildrenList extends AssistClasses.Step {
  constructor (cxt) {
    super('Список документов в пакете',
      (step) => this.fillSubTitle(step.model, step.props.scheme),
      {
        scheme: []
      },
      {
        selectedChildren: null,
        '/email-send/options': 'DEPO_LINK'
      }
    )
    this.context = cxt
    this.editable = true
    this.childrenItems = []
    this.macros = []
  }
  fillChildren (items) {
    if (!items) {
      this.props.scheme = []
      return this
    }
    this.childrenItems = items
    let lScheme = [
      {
        fieldType: 'v-select-check',
        name: 'selectedChildren',
        itemText: 'name',
        itemValue: 'id',
        items: (model, field) => this.parseChildrenList(model),
        size: {sm10: true}
      }
    ]
    this.props.scheme = lScheme
    return this
  }
  onActionClick (item) {
    profile.openLogAction(item.id, this.context.getMatterId())
  }
  getSelectedChildren (model) {
    if (!model['childrenList']) {
      return []
    }
    let deedsIds = model.selectedChildren && model['selectedChildren'].split(', ') || []
    return Object.values(JSON.parse(model['childrenList'])).filter(e => deedsIds.includes(e.deedId))
  }
  parseChildrenList (model) {
    const makeText = (e) => {
      let state = ''
      let text = e.name
      if (e.uploaded != null && e.logId != null) {
        state = '(начато депонирование)'
      }
      if (e.uploaded != null && e.logId == null && e.uid != null) {
        let url = this.context.getDepoUrl(e.uid)
        let file = `${url}/stream`
        state = `<a href="${file}" target="_blank">(версия:&nbsp${formats.formatDate(e.uploaded)})</a>`
      }
      if (e.uploaded != null && e.logId == null && e.uid == null) {
        state = `(пусто: ${formats.formatDate(e.uploaded)})`
      }
      if (e.uploaded == null && e.logId == null && e.uid == null) {
        state = e.checked != null ? `(проверено: ${formats.formatDate(e.checked)})` : ''
      }
      return `${text} ${state}`
    }
    let result = []
    try {
      Object.values(JSON.parse(model['childrenList'])).forEach(e => result.push({name: makeText(e), id: e.deedId}))
    } catch (e) {
      // pass
    }
    this.childrenItems = result
    return result
  }
  fillSubTitle (model, fields) {
    return model['selectedChildren'] &&
    `Выбрано ${model['selectedChildren'].split(', ').length} из ${this.childrenItems.length} документов` || ''
  }
}
class OperationList extends AssistClasses.Step {
  static getOperations () {
    return [
      // {value: 'OPEN', text: 'Открыть последнюю версию документа'},
      {value: 'SEND_BY_SERVER', text: 'Направить письмо и документы по электронной почте'},
      {value: 'ADD', text: 'Добавить новые документы в пакет'},
      {value: 'ATTACH_DOC', text: 'Прикрепить документы к пакету'},
      {value: 'UPDATE', text: 'Изменить данные в документах'},
      {value: 'DEPO', text: 'Депонировать документы'},
      {value: 'DOWNLOAD', text: 'Скачать депонированные документы'},
      {value: 'UPLOAD', text: 'Загрузить исправленную версию документа'},
      {value: 'OPEN_DOC', text: 'Открыть карточку депонирования документа'},
      {value: 'REMOVE_DOC', text: 'Удалить документы из пакета'},
      {value: 'CHANGE_DEED', text: 'Изменить тип пакета'}
    ]
  }
  constructor (cxt) {
    super('Операции',
      (step) => this.fillSubTitle(step.model, step.props.scheme),
      {
        scheme: []
      },
      {
        selectedChildren: null,
        '/email-send/options': 'DEPO_LINK'
      }
    )
    this.context = cxt
    this.editable = true
    this.childrenItems = []
    this.nextLabel = () => 'Выполнить'
    this.macros = []
  }
  fillChildren (items) {
    if (!items) {
      this.props.scheme = []
      return this
    }
    let lScheme = [
      {
        fieldType: 'v-select-radio',
        name: 'currentOperation',
        itemText: 'text',
        itemValue: 'value',
        items: (model) => this.getOperationsForSelected(model),
        size: {sm10: true}
      }
    ]
    this.props.scheme = lScheme
    return this
  }
  getSelectedChildren (model) {
    if (!model['childrenList']) {
      return []
    }
    let deedsIds = model.selectedChildren && model['selectedChildren'].split(', ') || []
    return Object.values(JSON.parse(model['childrenList'])).filter(e => deedsIds.includes(e.deedId))
  }
  getOperationsForSelected (model) {
    let ops = ['ADD', 'ATTACH_DOC']
    let children = this.getSelectedChildren(model)
    if (children.length > 0) {
      ops.push('DEPO', 'UPDATE', 'DOWNLOAD', 'SEND_BY_SERVER', 'REMOVE_DOC')
    }
    if (children.length === 1) {
      if (children[0] && children[0].uid) {
        ops.push('UPLOAD', 'OPEN_DOC')
      }
    }
    if (children.length === 0) {
      ops.push('CHANGE_DEED')
    }
    return OperationList.getOperations().filter(o => ops.includes(o.value))
  }
  fillSubTitle (model, fields) {
    return model['currentOperation'] &&
    `${this.getOperationsName(model)}` || 'Начните новую операцию'
  }
  getOperationsName (model) {
    let ops = [model.currentOperation]
    let operations = OperationList.getOperations().filter(o => ops.includes(o.value))
    return operations && operations.length > 0 && operations[0].text || ''
  }
  next (model, cb) {
    let operation = model.currentOperation
    if (['ATTACH_DOC', 'DEPO', 'UPLOAD', 'OPEN_DOC', 'DOWNLOAD', 'SEND_BY_SERVER', 'REMOVE_DOC'].includes(operation)) {
      return this.execute(model, cb)
    } else {
      return cb(model)
    }
  }
  execute (model, cb) {
    const _f = (val, def) => {
      if (val === null) {
        return def
      } else {
        return val
      }
    }
    var operation = model.currentOperation
    let children = this.getSelectedChildren(model)
    delete model.currentOperation
    switch (operation) {
      case 'DEPO':
        dialogs.confirm(this.context, 'Подтвердите', 'Сгенерировать новые версии документов и загрузить в депозитарий?',
          (self) => {
            model.currentState = 'DEPO'
            cb(model)
          })
        break
      case 'DOWNLOAD':
        let uids = []
        children.forEach(c => {
          if (c.uid) uids.push(c.uid)
        })
        depo.downloadFiles(uids)
        break
      case 'ATTACH_DOC':
        const onSelect = (values) => {
          if (Array.isArray(values)) {
            let set = new Set(values)
            model['selectedChildren'] = Array.from(set).map(uid => 'DEPO:' + uid).sort((a, b) => a - b).join(', ')
            model.currentState = 'ATTACH_DOC'
            cb(model)
          }
        }
        depo.selectDoc(this, onSelect, true, {path: this.context.getDepoCurrentPath})
        break
      case 'REMOVE_DOC':
        dialogs.confirm(this.context, 'Подтвердите', 'Удалить документы из пакета, документы останутся в депозитарии?',
          (self) => {
            model.currentState = 'REMOVE_DOC'
            cb(model)
          })
        break
      case 'OPEN_DOC':
        if (children.length === 1) {
          let child = children[0]
          if (child.uid) {
            let uid = child.uid
            const onNewVersion = () => {
              depo.newFile(this.context.getDepoCurrentPath, null, uid)
            }
            if (uid) {
              if (formats.isDepoUid(uid)) {
                depo.openFile(uid, this.context.getDepoCurrentPath, false, onNewVersion)
              }
            }
          } else {
            dialogs.message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий')
          }
        }
        break
      case 'UPLOAD':
        if (children.length === 1) {
          let child = children[0]
          if (child.uid) {
            let uid = child.uid
            depo.newFile(null, null, uid)
          }
        }
        break
      case 'SEND_BY_SERVER': {
        let uids = []
        children.forEach(c => {
          if (c.uid) uids.push(c.uid)
        })
        dialogs.confirm(this.context, 'Подтвердите', 'К письму прикрепляются актуальные версии из депозитария.' +
         ' Если документ отсутствует он будет создан. Продолжить?',
          (self) => {
            this.context.updateData(model)
            if (this.context.getIsAllow({SEND_MAIL: null})) {
              let macros = [
                {k: '/email-send/to', t: 'text'},
                {k: '/email-send/body', t: 'html'},
                {k: '/email-send/subject', t: 'text'}
              ]
              this.calcMacros(macros, model).then(obj => {
                forms.openEmail({
                  uids: uids,
                  to: _f(obj['/email-send/to'], model['/email-send/to']),
                  subject: _f(obj['/email-send/subject'], model['/email-send/subject']),
                  body: _f(obj['/email-send/body'], model['/email-send/body']),
                  options: model['/email-send/options'],
                  mailbox: model['/email-send/mailbox']
                }).then(data => {
                  let request = {
                    id: this.context.getMatterId(),
                    parts: children.map(c => c.deedId).join(', '),
                    email: data.email,
                    subject: data.subject,
                    body: data.body,
                    mailbox: data.mailbox,
                    scheduled: data.scheduled
                  }
                  // console.log('SEND_BY_SERVER', request)
                  this.context.$store.dispatch('sendAssistMatter', request)
                })
              })
            } else {
              dialogs.message(this.context, 'Совет', 'Вы не можете посылать письма, сначала включите функцию рассылки для компании')
            }
          })
      }
        break
    }
  }
  calcMacros (macros, model) {
    const calcMacro = (macro, type) => {
      return Promise.resolve(macro)
      .then(() => {
        if (/xslt:/ig.test(macro)) {
          return this.context.macro(macro)
        }
        return macro
      })
      .then(html => {
        if (/text/ig.test(type)) {
          let toDiv = document.createElement('div')
          toDiv.innerHTML = html
          return toDiv.innerText
        }
        return html
      })
    }
    return macros.reduce(
      (p, e) => {
        return p.then(obj => {
          return calcMacro(model[e.k], e.t)
          .then(data => {
            obj[e.k] = data
            return obj
          })
        })
      },
      Promise.resolve({})
    )
  }
}

class ChildrenSelect extends AssistClasses.Step {
  constructor (cxt) {
    super('Выберите документы для добавления',
      (step) => this.fillSubTitle(step.model, step.props.scheme),
      {
        scheme: []
      },
      {
        selectedChildren: null
      }
    )
    this.context = cxt
    this.editable = true
    this.childrenItems = []
  }
  fillChildren (items) {
    if (!items) {
      this.props.scheme = []
      return this
    }
    this.childrenItems = items
    let lScheme = [
      {
        fieldType: 'v-select-check',
        name: 'selectedChildren',
        itemText: 'name',
        itemValue: 'id',
        items: this.childrenItems,
        size: {sm10: true}
      }
    ]
    this.props.scheme = lScheme
    return this
  }
  fillSubTitle (model, fields) {
    return model['selectedChildren'] &&
    `Выбрано ${model['selectedChildren'].split(',').length} из ${this.childrenItems.length} документов` || ''
  }
}

class DocumnentCheck extends AssistClasses.Step {
  static getStates () {
    return [
      {value: 'CHECKED', text: 'Подготовка завершена'},
      {value: 'DEPO', text: 'Поместить в депозитарий'}
    ]
  }
  constructor (cxt) {
    super(
      'Подготовьте документы',
      (step) => this.fillSubTitle(step.model, step.props.scheme),
      {
        scheme: [
          {
            fieldType: 'v-select',
            label: 'Формат документа',
            itemValue: 'value',
            itemText: 'text',
            items: (model, field) => {
              return cxt.getDeedFormats()
            },
            name: 'deedFormat',
            shrink: false,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-select-check',
            name: 'currentState',
            itemText: 'text',
            itemValue: 'value',
            items: (model, field) => DocumnentCheck.getStates(),
            size: {sm10: true}
          }
        ]
      },
      {
        depoLink: null
      })
    this.context = cxt
    this.nextEnabled = () => this.model.currentState && this.model.currentState.includes('CHECKED')
  }
  fillSubTitle (model, fields) {
    return model.depoLink ? this.context.getDepoUrl(model.depoLink) : ''
  }
  next (model, cb) {
    model.setCurrentStep(1)
    delete model.currentOperation
    this.context.updateData(model)
    return model
  }
}

class PackageStrategy extends AssistClasses.Strategy {
  constructor (cxt) {
    super(cxt)
    this.childrenStep = null
  }
  getTypeCode () {
    return 'PACKAGE'
  }
  next (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      if (currentStep <= this.steps.length) {
        currentStep = currentStep + 1
      } else {
        currentStep = 1
        delete model.currentOperation
      }
      console.log('next', currentStep, this.steps)
      model.setCurrentStep(currentStep)
      this.context.updateData(model)
      return model
    }
    return step && step.next ? step.next(model, cb) : model
  }
  getCurrentStep (model) {
    return this.steps.find(step => step.number === model.getCurrentStep())
  }
  back (model, step) {
    const cb = (model) => {
      var currentStep = step.number
      if (currentStep > 1) {
        currentStep = currentStep - 1
        model.setCurrentStep(currentStep)
        this.context.updateData(model)
      } else {
        this.context.refreshData()
      }
      return model
    }
    return step && step.back ? step.back(model, cb) : model
  }

  complete (model, step) {
    return step && model && model.getCurrentStep() > step.number
  }

  editable (model, step) {
    return step.editable || (model && model.getCurrentStep() === step.number)
  }

  previewable (model) {
    return (model && model.getCurrentStep() > 1)
  }

  updateSteps (scheme) {
    var steps = []
    var cxt = this.context
    if (!(scheme && scheme.steps && scheme.steps.length > 0)) {
      Object.assign(new DocumnentSelectType(cxt), {backLabel: () => 'Отмена'})
      .addToArray(steps)

    }
    if (scheme && scheme.steps && scheme.steps.length > 0) {
      this.childrenStep = new ChildrenList(cxt)
      .fillChildren(scheme.steps[0].fields)
      new OperationList(cxt)
      .fillChildren(scheme.steps[0].fields)
      .addToArray(steps)
    }
    if (scheme && scheme.steps && scheme.steps.length > 2) {
      new ChildrenSelect(cxt)
      .fillChildren(scheme.steps[2].fields)
      .addToArray(steps)
    }

    if (scheme && scheme.steps && scheme.steps.length > 1) {
      new StepSetParameters.Step(cxt)
      .fillFields(scheme.steps[1].fields)
      .addToArray(steps)

      new DocumnentCheck(cxt)
      .addToArray(steps)

      // new DocumnentOperations(cxt)
      // .addToArray(steps)
    }

    this.steps = steps
    return this
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
    if (this.childrenStep) {
      this.childrenStep.setModel(model)
    }
  }
  createModel () {
    var model = new Model()
    if (this.context) {
      model['companyInn'] = this.context.profile.clientInn
      model['companyRefCode'] = this.context.profile.clientRefCode
    }
    this.steps.forEach((step) => Object.assign(model, step.model))
    return model
  }
}

function createStrategy (cxt) {
  return new PackageStrategy(cxt)
}

class Model extends AssistClasses.Model {
  constructor () {
    super()
    this.deedNumber = null
  }

  copy () {
    return Object.assign(new Model(), this)
  }

}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/assist/PackageSteps.js